export const READY_PRODUCTS_SERVICE_INFO_QUERY_KEY = () => [
  "rtb",
  "service-info",
];
export const ITEMS_SERVICE_INFO_QUERY_KEY = () => ["items", "service-info"];
